import { animate, style, transition, trigger } from '@angular/animations';

import { Component, EventEmitter, Output, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { NavigationItem } from '../header/header.component';

@Component({
    selector: 'pax-fullscreen-menu',
    standalone: true,
    imports: [RouterLink, LucideAngularModule],
    templateUrl: './fullscreen-menu.component.html',
    styleUrls: ['./fullscreen-menu.component.scss'],
    animations: [
        trigger('menuAnimation', [
            transition(':enter', [
                style({
                    clipPath: 'circle(0% at bottom right)',
                    opacity: 0,
                }),
                animate(
                    '600ms cubic-bezier(0.86, 0, 0.07, 1)',
                    style({
                        clipPath: 'circle(150% at bottom right)',
                        opacity: 1,
                    }),
                ),
            ]),
            transition(':leave', [
                style({
                    clipPath: 'circle(150% at bottom right)',
                    opacity: 1,
                }),
                animate(
                    '500ms cubic-bezier(0.86, 0, 0.07, 1)',
                    style({
                        clipPath: 'circle(0% at bottom right)',
                        opacity: 0,
                    }),
                ),
            ]),
        ]),
        trigger('menuItems', [
            transition(':enter', [
                style({
                    transform: 'translateX(80px)',
                    opacity: 0,
                }),
                animate(
                    '400ms 400ms cubic-bezier(0.35, 0, 0.25, 1)',
                    style({
                        transform: 'translateX(0)',
                        opacity: 1,
                    }),
                ),
            ]),
        ]),
    ],
})
export class FullscreenMenuComponent {
    readonly isOpen = input(false);
    readonly navigationItems = input<NavigationItem[]>([]);
    readonly availableLanguages = input<string[]>([]);
    readonly currentLang = input('');
    @Output() closeMenu = new EventEmitter<void>();
    @Output() languageChange = new EventEmitter<string>();
}
